import { combineReducers } from 'redux';

import auditLogs from './audit_logs/reducer';
import builds from './builds/reducer';
import comments from './comments/reducer';
import dependenciesV2 from './dependenciesV2/reducer';
import { reducer as globalLicenseCorrections } from './globalLicenseCorrections/slice';
import issuesV2 from './issuesV2/reducer';
import navigation from './navigation/reducer';
import organizationAccessRequests from './organization_access_requests/reducer';
import organizations from './organizations/reducer';
import packageInventory from './packageInventory/reducer';
import policies from './policies/reducer';
import projectGroups from './project_grouping/reducer';
import projects from './projects/reducer';
import projectsV2 from './projectsV2/reducer';
import rawVulns from './raw_vulns/reducer';
import savedFilters from './savedFilters/reducer';
import teams from './teams/reducer';
import users from './users/reducer';
import vcs from './vcs/reducer';
import vulns from './vulns/reducer';

const rootReducer = combineReducers({
  auditLogs,
  builds,
  comments,
  issuesV2,
  savedFilters,
  navigation,
  organizations,
  organizationAccessRequests,
  packageInventory,
  policies,
  projects,
  projectsV2,
  projectGroups,
  rawVulns,
  teams,
  users,
  vcs,
  vulns,
  globalLicenseCorrections,
  dependenciesV2,
});

export default rootReducer;
